import React, { useEffect, useState } from "react";
import { Form, Button } from "react-bootstrap";
import { authServices } from "../../services/auth.services";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import TextField from "@mui/material/TextField";
import { Autocomplete } from "@mui/material";
import schoolServices from "../../services/school_services";
import studentServices from "../../services/student.services";
const SchoolInfoCard = (props) => {
    const navigate = useNavigate()
    const [schoolInfoData, setSchoolInfoData] = useState()
    const [schoolListGet, setSchoolListGet] = useState()
    const [schoolList, setSchoolList] = useState([])
    const [form, formData] = useState({ school_name: "", })

    useEffect(() => {

        schoolServices.getSchoolProfile().then(resp => {
            setSchoolInfoData(prev => ({ ...prev, ...resp.data }))
            setSchoolInfoData(prev => ({ ...prev, ...resp.data.school }))
        }).catch(err => console.log(err))
    }, [])



    useEffect(() => {

        studentServices.getSchoolList().then(resp => {
            resp.data.map((curr, index) => (
                setSchoolList(prevState => ([...prevState,
                { school_id: curr._id, country: curr.country, label: curr.school_name, key: curr._id }]))
                // setSchoolList(prevState => ([...prevState,
                // {
                //     school_id: curr._id,
                //     country: curr.country,
                //     label: curr.school_name,
                //     key: curr._id
                // }]))
            )
            )
        }).catch(err => console.log(err))

    }, [])

    const handleChange = (e) => {
        const name = e.target.name
        const value = e.target.value
        formData({
            ...form,
            [name]: value
        })
    }


    const updateSchoolInfo = (e) => {
        authServices.completeSchoolInfo(form)
            .then(resp => {
                toast.success("SignUp Successful")
                navigate('/school-dashboard')
            })
            .catch(err => {
                console.log(err)
                toast.error(err.message)
            })
        e.preventDefault()
    }




    return (
        <>
            <div className="sign_hdng">
                <h2>School Information</h2>
            </div>
            <Form onSubmit={(e) => { updateSchoolInfo(e) }} className="signform_div">
                <Form.Group
                    className="mb-3"
                    controlId="formBasicEmail"
                >
                    <Form.Label>School Name </Form.Label>
                    {props && props.type === "edit" ?
                        <Form.Control
                            onChange={(e) => { handleChange(e) }}
                            required
                            defaultValue={schoolInfoData && schoolInfoData.school_name && schoolInfoData.school_name}
                            name='name_of_person'
                            type="text"
                            disabled
                            placeholder="Enter Name of person of contact from school"
                        />
                        :
                        <Autocomplete
                            disablePortal
                            id="controllable-states-demo"
                            defaultValue={schoolInfoData && schoolInfoData.school_name && schoolInfoData.school_name}
                            inputValue={schoolInfoData && schoolInfoData.school_name && schoolInfoData.school_name}
                            options={schoolList}
                            name="school_name"
                            onChange={(e, newInputValue, reason, details) => {
                                if (details?.option.label && details?.option.school_id) {
                                    formData({
                                        ...form,
                                        "school_name": details.option.label,
                                        "school_id": details.option.school_id,
                                    })
                                }
                                else {
                                    formData({
                                        ...form,
                                        "school_name": '',
                                        "school_id": '',
                                    })
                                }
                            }
                            }
                            renderOption={(props, option) => {
                                return (
                                    <li {...props} value={option.label} key={option.key}>
                                        {option.label + " " + `(${option.country})`}
                                    </li>
                                );
                            }}
                            renderInput={(params) => <TextField {...params}
                                name="school_name"
                                onChange={(e) => { handleChange(e) }}
                                label="Search For School"
                            />}
                        />
                    }

                </Form.Group>
                <Form.Group
                    className="mb-3"
                    controlId="formBasicEmail"
                >
                    <Form.Label>
                        Name of person of contact from
                        school{" "}
                    </Form.Label>
                    <Form.Control
                        onChange={(e) => { handleChange(e) }}
                        required
                        defaultValue={schoolInfoData && schoolInfoData?.schoolInfoData?.name_of_person ? schoolInfoData.schoolInfoData.name_of_person : ""
                        }
                        name='name_of_person'
                        type="text"
                        placeholder="Enter Name of person of contact from school"
                    />
                </Form.Group>

                <Form.Group
                    className="mb-3"
                    controlId="formBasicEmail"
                >
                    <Form.Label>Phone Number</Form.Label>
                    <Form.Control
                        required
                        defaultValue={schoolInfoData && schoolInfoData.schoolInfoData?.phone ? schoolInfoData.schoolInfoData?.phone : ""
                        }
                        onChange={(e) => { handleChange(e) }}
                        name='phone'
                        type="number"
                        placeholder="Enter Phone Number"
                    />
                </Form.Group>

                <Form.Group
                    className="mb-3"
                    controlId="exampleForm.ControlTextarea1"
                >
                    <Form.Label>School Address</Form.Label>
                    <Form.Control
                        onChange={(e) => { handleChange(e) }}
                        required
                        defaultValue={schoolInfoData && schoolInfoData.schoolInfoData?.school_address ? schoolInfoData.schoolInfoData?.school_address : ""
                        }
                        name="school_address"
                        as="textarea" rows={3} />
                </Form.Group>
                <Button
                    className="btn_theme w-100 mt-4"
                    type="submit"
                >
                    Submit
                </Button>
            </Form>
        </>

    );
};

export default SchoolInfoCard;
